const NAVI_HOSTS = new Set([
  "caribnavi.com",
  "www.caribnavi.com",
  "app.caribnavi.com",
  "api.caribnavi.com",
  "bajan-premier-pulse.pages.dev",
]);
const NAVI_WORKER_HOSTS = new Set([
  "app.caribnavi.com",
  "api.caribnavi.com",
  "bajan-premier-pulse.rrkinc-2025.workers.dev",
]);
const NAVI_APEX_HOSTS = new Set([
  "caribnavi.com",
  "www.caribnavi.com",
  "bajan-premier-pulse.pages.dev",
]);
const NAVI_API_ORIGIN = "https://digitalhustlerscaribbean.com";
const CHEEPSWEEPZ_HOSTS = new Set([
  "cheepsweepz.shop",
  "www.cheepsweepz.shop",
  "app.cheepsweepz.shop",
  "api.cheepsweepz.shop",
  "cheepsweepz-concierge.pages.dev",
]);
const CHEEP_WORKER_HOSTS = new Set([
  "app.cheepsweepz.shop",
  "api.cheepsweepz.shop",
  "cheepsweepz-concierge.rrkinc-2025.workers.dev",
]);
const CHEEP_APEX_HOSTS = new Set([
  "cheepsweepz.shop",
  "www.cheepsweepz.shop",
  "cheepsweepz-concierge.pages.dev",
]);
const DHC_HOSTS = new Set([
  "digitalhustlerscaribbean.com",
  "www.digitalhustlerscaribbean.com",
  "digital-hustlers-caribbean.workers.dev",
]);

const DEFAULT_PROFILE = {
  id: "bajan-premier",
  brandName: "Bajan Premier",
  documentTitle: "Bajan Premier | The Digital Pulse of Barbados",
  heroTitlePrefix: "The Digital Pulse of",
  heroTitleAccent: "Barbados",
  heroSubtitle: "Discover • Book • Experience • Stay",
  welcomeToast: "Welcome to Bajan Premier!",
  assistantName: "Island Assistant",
  assistantWelcomeMessage: "Welcome to Bajan Premier. How can I help you discover Barbados today?",
  assistantSourceLabel: "Live assistant configuration for Bajan Premier",
  standaloneTickerLabel: "ALL SYSTEMS LIVE",
  paymentStatusLabel: "Live commerce checks in progress...",
};

const NAVI_PROFILE = {
  id: "navi",
  brandName: "CaribNavi",
  documentTitle: "CaribNavi | Caribbean Concierge",
  heroTitlePrefix: "Your Caribbean",
  heroTitleAccent: "Navigator",
  heroSubtitle: "Discover • Navigate • Book • Explore",
  welcomeToast: "Welcome to CaribNavi!",
  assistantName: "Navi Assistant",
  assistantWelcomeMessage: "Welcome to CaribNavi. How can I help you plan today?",
  assistantSourceLabel: "Standalone assistant configuration for CaribNavi",
  standaloneTickerLabel: "🌴 Navi Standalone Active",
  paymentStatusLabel: "Business commerce bridge: checking...",
};

const CHEEPSWEEPZ_PROFILE = {
  id: "cheepsweepz",
  brandName: "CheepSweepz",
  documentTitle: "CheepSweepz | Retail and Shipping Live",
  heroTitlePrefix: "Retail Flow",
  heroTitleAccent: "Activated",
  heroSubtitle: "Track • Sell • Ship • Repeat",
  welcomeToast: "Welcome to CheepSweepz!",
  assistantName: "Sweep Assistant",
  assistantWelcomeMessage: "CheepSweepz keeps your retail and logistics flow moving in real time.",
  assistantSourceLabel: "Live retail orchestration for CheepSweepz",
  standaloneTickerLabel: "🛒 CheepSweepz Retail Online",
  paymentStatusLabel: "Retail handshake: checking...",
};

const DHC_PROFILE = {
  id: "dhc-hq",
  brandName: "Digital Hustlers Caribbean",
  documentTitle: "Digital Hustlers Caribbean | Command Hub",
  heroTitlePrefix: "DHC HQ",
  heroTitleAccent: "Live",
  heroSubtitle: "Build • Market • Route • Scale",
  welcomeToast: "Welcome to DHC HQ!",
  assistantName: "HQ Assistant",
  assistantWelcomeMessage: "The command hub is monitoring all Mansion network traffic.",
  assistantSourceLabel: "HQ command feed for Digital Hustlers Caribbean",
  standaloneTickerLabel: "🌐 DHC HQ | ALL SYSTEMS LIVE",
  paymentStatusLabel: "HQ orchestration: checking...",
};

function normalizeHostname(hostname) {
  return String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, "");
}

export function getRuntimeHostname() {
  if (typeof window === "undefined") {
    return "";
  }

  return normalizeHostname(window.location.hostname);
}

export function getSiteProfile(hostname = getRuntimeHostname()) {
  const normalized = normalizeHostname(hostname);
  if (NAVI_HOSTS.has(normalized) || normalized.endsWith(".bajan-premier-pulse.pages.dev")) {
    return NAVI_PROFILE;
  }
  if (CHEEPSWEEPZ_HOSTS.has(normalized)) {
    return CHEEPSWEEPZ_PROFILE;
  }
  if (DHC_HOSTS.has(normalized)) {
    return DHC_PROFILE;
  }
  return DEFAULT_PROFILE;
}

export function isNaviHost(hostname = getRuntimeHostname()) {
  const normalized = normalizeHostname(hostname);
  return NAVI_HOSTS.has(normalized) || normalized.endsWith(".bajan-premier-pulse.pages.dev");
}

export function isCheepSweepzHost(hostname = getRuntimeHostname()) {
  return getSiteProfile(hostname).id === "cheepsweepz";
}

export function getConfiguredApiOrigin() {
  return (
    process.env.REACT_APP_API_ORIGIN ||
    process.env.REACT_APP_HQ_URL ||
    process.env.NEXT_PUBLIC_API_ORIGIN ||
    process.env.NEXT_PUBLIC_HQ_URL ||
    process.env.VITE_HQ_URL ||
    ""
  );
}

export function getApiBaseUrl() {
  if (typeof window !== "undefined") {
    const hostname = getRuntimeHostname();
    if (CHEEP_WORKER_HOSTS.has(hostname)) {
      return `${window.location.origin}/api`;
    }
    if (CHEEP_APEX_HOSTS.has(hostname)) {
      return "https://app.cheepsweepz.shop/api";
    }
    if (NAVI_WORKER_HOSTS.has(hostname)) {
      return `${window.location.origin}/api`;
    }
    if (NAVI_APEX_HOSTS.has(hostname)) {
      return "https://app.caribnavi.com/api";
    }
    if (isNaviHost(hostname)) {
      const configuredOrigin = getConfiguredApiOrigin().replace(/\/$/, "");
      if (configuredOrigin) {
        return configuredOrigin.endsWith("/api") ? configuredOrigin : `${configuredOrigin}/api`;
      }
      return `${NAVI_API_ORIGIN}/api`;
    }
  }

  const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (backend && !backend.includes("localhost")) {
    return backend.endsWith("/api") ? backend : `${backend}/api`;
  }

  const configuredOrigin = getConfiguredApiOrigin().replace(/\/$/, "");
  if (configuredOrigin) {
    return configuredOrigin.endsWith("/api") ? configuredOrigin : `${configuredOrigin}/api`;
  }

  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }

  return "/api";
}

export function getNaviStatusUrl() {
  return `${getApiBaseUrl()}/navi/status`;
}
